import { useState } from "react";

export interface DatasetLoad {
  readonly loading: boolean;
  readonly loaded: number;
  readonly total: number;
  // Runs the given loaders in parallel, tracking N-of-M completion for a progress gate. Resolves with the results
  // (in order); rejects if any loader fails (caller surfaces the error). `loading` flips false when all settle.
  readonly load: <T = any>(thunks: Array<() => Promise<T>>) => Promise<T[]>;
}

// Drives an N-of-M loading gate for dialogs whose open-load is a flat set of independent requests.
export function useDatasetLoad(): DatasetLoad {
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(0);
  const [total, setTotal] = useState(0);

  function load<T = any>(thunks: Array<() => Promise<T>>): Promise<T[]> {
    setTotal(thunks.length);
    setLoaded(0);
    setLoading(true);

    const tracked = thunks.map((thunk) =>
      thunk().then((result) => {
        setLoaded((n) => n + 1);
        return result;
      }),
    );

    return Promise.all(tracked).finally(() => setLoading(false));
  }

  return { loading, loaded, total, load };
}
